<script setup>
import { ref ,onMounted} from 'vue'
import { Link } from '@inertiajs/inertia-vue3'
import stripslashes, { replaceS3path } from '@/Shared/helper.js'
import useIsotope from '@/Shared/useIsotope.js'
import Sidebar from './Sidebar.vue'

const props = defineProps({
  newsList: Array,
})

const containerRef = ref()

const isotope = (data) => {
  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: data,
    key: 'newsThumb',
  })
}

onMounted(() => {
  isotope(props.newsList)
})

</script>

<template>
  <Sidebar class="brand v2">
    <h2 class="lg:block text-[50px] xs:text-[60px] sm:text-[70px] md:text-[80px] lg:text-[80px] mb-10 md:mb-20 font-rift font-bold text-center">
      NEWS
      <small class="font-jpsans block mt-2 sm:mt-3 text-[15px] sm:text-[18px]">関連ニュース</small>
    </h2>
    <ul ref="containerRef" class="isotope-container pb-[50px] md:pb-[10px]">
      <li v-for="news in newsList" :key="news.newsID" class="isotope-item hover-item">
        <Link :href="`/news/${news.newsCategory}/${news.newsSlug}`">
          <img :src="replaceS3path(news.newsThumb)" :alt="stripslashes(news.newsTitle)" class="w-full" />
          <h4 class="title hidden">{{ news.newsTitle }}</h4>
        </Link>
      </li>
    </ul>
  </Sidebar>
</template>
